import { Component, OnInit } from '@angular/core';
import { GlobalConstants } from 'src/app/services/global-variables';
import { ApiService } from 'src/app/services/api.service';
import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AubTrackingService } from 'src/app/services/aub-tracking.service';
import { AubGTMTrackingService } from 'src/app/services/aub-gtm-tracking.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-search-basic',
  templateUrl: './search-basic.component.html',
  styleUrls: ['./search-basic.component.scss'],
  providers: [ GlobalConstants,ApiService]
})


export class SearchBasicComponent implements OnInit {
  private subject: Subject<string> = new Subject();
  searching: boolean = false;
  searchInput: string = '';
  nearBymerchantList: any = [];
  merchantList: any = [];
  selectedCat: any = '';

  constructor(
    public GlobalConstants: GlobalConstants,
    public _apiService: ApiService,
    private _aubts: AubTrackingService,
    private _aubgtm: AubGTMTrackingService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.subject.pipe(
      debounceTime(300)
    ).subscribe(searchTextValue => {
      this.populateMerchantList(searchTextValue);
    });
  }
  debouncedPopulateMerchantList(searchTextValue: any) {
    this.subject.next(searchTextValue);
  }

  gtmSearchBar(searchText:string) {
    this._aubgtm.pushToDataLayer(
      {
        'event': 'offers_searchbar',
        'EventCategory': 'Search for Offer',
        'EventAction': searchText
      }
    )
    this._aubts.aubts_offers_search(searchText);
  }

  populateMerchantList(event:any) {
    this.searchInput = event.target.value;
    if (event.target.value.length > 2) {
      this.searching = true;
      this.merchantList = [];
      this._apiService.getMerchants({ name: event.target.value }).subscribe(
        (res: any) => {
          this.merchantList = res.data.slice(0, 7);
          setTimeout(() => { this.searching = false; }, 500);
        },
        (err) => {
          this.searching = false;
        }
      );
    }
    else {
      this.merchantList = [];
      this.searching = false;
    }
  }

 
}
